import { IBusinessPartnerInfo } from '.';
import { IAbstractRecord } from '@models';
import {
  capitalizeFirstLetter,
  valueCommaSeparated,
} from '@utils/formatting-utils';

export function entityToBusinessPartnerDetails(
  data: IAbstractRecord
): IBusinessPartnerInfo {
  const businessPartnerDetailsInfo =
    data?.SalesforceManagement?.entities?.businessPartner?.views
      ?.SalesforceManagement_all?.properties;
  const personDetailsInfo =
    businessPartnerDetailsInfo.PersonID?.views?.SalesforceManagement_all
      ?.properties;
  const businessPartnerRetaledUsersInfo =
    data?.SalesforceManagement?.entities?.businessPartner?.queries
      ?.salesforceManagement?.relatedUsers[0];

  return {
    name: personDetailsInfo?.FullName,
    businessPartnerCode: businessPartnerDetailsInfo?.Code,
    businessPartnerStatus: businessPartnerDetailsInfo?.Status.toLowerCase(),
    businessPartnerType: businessPartnerDetailsInfo?.Type?.Id,
    status: businessPartnerDetailsInfo?.Status.toLowerCase(),
    personCode: personDetailsInfo?.PersonCode,
    personId: businessPartnerDetailsInfo?.PersonID?.id,
    dateOfBirth: personDetailsInfo?.DateOfBirth,
    email: personDetailsInfo?.Email,
    phoneNumber: personDetailsInfo?.PhoneDetails?.PhoneNumber,
    phoneType: capitalizeFirstLetter(
      personDetailsInfo?.PhoneDetails?.PhoneType
    ),
    taxable: personDetailsInfo?.IsTaxable,

    createdBy: `${businessPartnerRetaledUsersInfo?.createdBy_firstName} ${businessPartnerRetaledUsersInfo?.createdBy_lastName}`,
    createdOn: businessPartnerDetailsInfo?.createdOn,
    modifiedBy: `${businessPartnerRetaledUsersInfo?.modifiedBy_firstName} ${businessPartnerRetaledUsersInfo?.modifiedBy_lastName}`,
    modifiedOn: businessPartnerDetailsInfo?.modifiedOn,

    type: businessPartnerDetailsInfo.Type?.Id,
    typeTitle: businessPartnerDetailsInfo.Type?.Title,
    taxAccount: businessPartnerDetailsInfo.TaxAccount,
    account: businessPartnerDetailsInfo.Account,
    registerNumber: businessPartnerDetailsInfo.RegisterNumber,
    isRegistered: businessPartnerDetailsInfo.IsRegistered,
    isLocal: businessPartnerDetailsInfo.IsLocal,
    allowAccessToAllInsured: businessPartnerDetailsInfo.AllowAccessToAllInsured,
    isCompany: businessPartnerDetailsInfo.IsCompany,
    category: businessPartnerDetailsInfo.Category?.Id,
    categoryTitle: businessPartnerDetailsInfo.Category?.Title,
    relatedCompany: businessPartnerDetailsInfo.RelatedCompany?.Id,
    relatedCompanyTitle: businessPartnerDetailsInfo.RelatedCompany?.Title,

    SalesforceManagement_BusinessPartnerStatuses:
      businessPartnerDetailsInfo.Status,
    maxCreditLimitAllowedCurrency:
      businessPartnerDetailsInfo.MaxCreditLimitAllowedCurrency?.Id,
    maxCreditLimitAllowedCurrencyTitle:
      businessPartnerDetailsInfo.MaxCreditLimitAllowedCurrency?.Title,
    maxCreditLimitAllowed: businessPartnerDetailsInfo.MaxCreditLimitAllowed,
    maxCreditLimitAllowedShow: valueCommaSeparated(
      businessPartnerDetailsInfo.MaxCreditLimitAllowed
    ),
  };
}
